import { useContext, useState } from 'react'

// custom components
import ViewMode from './ViewMode'
import EditMode from './EditMode'
import ServiceDetailAdmin from './ServiceDetailAdmin'

// context
import { GlobalContext } from '../../../../services/context/DataContext'

const useServiceDetail = () => {
  const { selectedServiceData } = useContext(GlobalContext)
  const [selectedService] = selectedServiceData
  const [isOpen, setIsOpen] = useState(true)
  const viewSwitcher = (
    editMode,
    admin,
    data,
    reorderFields,
    index,
    updateFieldLabel,
    toggleDeleteConfirmationModal,
    resetToDefault,
    isCardDirty,
    toggleIsHidden,
    updateDataType
  ) => {
    const { cardData } = data
    if (editMode) {
      return (
        <EditMode
          data={cardData}
          selectedService={selectedService}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          cardIndex={index}
        />
      )
    } else if (admin) {
      return (
        <ServiceDetailAdmin
          data={cardData}
          index={index}
          reorderFields={reorderFields}
          resetToDefault={resetToDefault}
          isCardDirty={isCardDirty}
          updateDataType={updateDataType}
          updateFieldLabel={updateFieldLabel}
          toggleDeleteConfirmationModal={toggleDeleteConfirmationModal}
          toggleIsHidden={toggleIsHidden}
        />
      )
    } else {
      return (
        <ViewMode
          data={cardData}
          index={index}
          reorderFields={reorderFields}
          resetToDefault={resetToDefault}
          isCardDirty={isCardDirty}
          updateFieldLabel={updateFieldLabel}
          toggleDeleteConfirmationModal={toggleDeleteConfirmationModal}
        />
      )
    }
  }

  return {
    selectedService,
    isOpen,
    setIsOpen,
    viewSwitcher
  }
}

export default useServiceDetail
